<template>
  <div class="projectstructure-element-value">
    <slot />

    <TIconButton
      v-if="!show_input && is_edit_mode"
      icon="link"
      tooltip="Map value"
      :color="foreground_color"
      @clickIcon="show_input = true"
    />

    <div
      v-if="show_input"
      class="projectstructure-element-value-actions"
    >
      <input
        v-if="!map_value && !set_ifc_type"
        class="projectstructure-element-value-input"
        :type="input_type"
        @change="value = $event.target.value"
      />

      <DropDownOutlinedFlat
        v-if="map_value || set_ifc_type"
        :options="dropdown_values"
        :value="mapping_selection"
        :width="130"
        :height="30"
        :foreground_color="foreground_color"
        :background_color="background_color"
        @change="mapping_selection.value = $event"
      />

      <TIconButton
        icon="check"
        tooltip="OK"
        :color="foreground_color"
        @clickIcon="map_value || set_ifc_type
          ? ($emit('mapValue', mapping_selection), show_input = false)
          : ($emit('changeValue', input_type === 'number'
              ? parseFloat(value)
              : value),
            show_input = false)"
      />

      <TIconButton
        icon="sign-close"
        tooltip="Cancel"
        :color="foreground_color"
        @clickIcon="show_input = false"
      />
    </div>
  </div>
</template>

<script>
  import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
  // import TIcon from '@/components/Taktify/TIcon.component.vue';
  import TIconButton from '@/components/Taktify/TIconButton.component.vue';

  export default {
    props: [
      'input_type',
      'map_value',
      'set_ifc_type',
      'value_is_number',
      'is_edit_mode',
      'set_material',
      'foreground_color',
      'background_color',
    ],

    components: {
      DropDownOutlinedFlat,
      TIconButton,
    },

    data: () => ({
      show_input: false,
      value: "",
      mapping_selection: {text: 'Name', value: 'name'},
    }),

    created() {
      if (this.set_ifc_type) {
        this.mapping_selection.text = 'IFCPROJECT';
        this.mapping_selection.value = 'IFCPROJECT';
      }
      if (this.set_material) {
        this.mapping_selection.text = 'Length';
        this.mapping_selection.value = 'length';
      }
    },

    computed: {
      dropdown_values() {
        let values = [];
        if (this.set_ifc_type) {
          values = this.$store.state.Ultra.ifc_types;
        } else if (this.set_material) {
          values = [
            {text: 'Length', value: 'length'},
            {text: 'Width', value: 'width'},
            {text: 'Height', value: 'height'},
            {text: 'Price', value: 'price'},
            {text: 'Carbon Dioxide', value: 'carbon_dioxide'},
            {text: 'Weight', value: 'weight'},
          ];
        } else {
          values = [{text: 'Name', value: 'name'}, {text: 'Description', value: 'description'}];
          if (this.value_is_number) {
            this.$store.state.Ultra.ifc_geometry_values.forEach(val => {
              values.push({text: val.text, value: val.prop});
            });
          }
        }
        return values;
      }
    }
  }
</script>

<style>
  .projectstructure-element-value {
    display: flex;
    width: 100%;
    min-height: 30px;
    /* border-bottom: 1px solid black; */
    align-items: center;
  }
  .projectstructure-element-value-input {
    border: 1px black solid;
    border-radius: 5px;
    background-color: white;
    color: black;
  }
  .projectstructure-element-value-input:focus {
    outline: none;
  }
  .projectstructure-element-value-actions {
    display: flex;
    grid-gap: 4px;
    align-items: center;
  }
</style>
